/**
 * Authentication Context
 * Provides global authentication state management and user information storage
 */

import { createContext, useState } from "react";

/**
 * Context object for authentication state management
 * @type {React.Context<{auth: Object, setAuth: Function}>}
 */
const AuthContext = createContext({});

/**
 * Authentication Provider Component
 * Manages authentication state and provides it to child components
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to be wrapped
 * @returns {JSX.Element} Authentication context provider wrapper
 */
export const AuthProvider = ({ children }) => {
  /**
   * Authentication state
   * Initializes from localStorage if available, otherwise defaults to null
   * @type {[Object, Function]} Authentication state and setter
   */
  const [auth, setAuth] = useState({
    userInfo: localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : null,

    userRole: localStorage.getItem("userRole")
      ? JSON.parse(localStorage.getItem("userRole"))
      : null,
  });

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
